module.exports = __webpack_public_path__ + "img/academy_popup_7.dac1ff4c.svg";